function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as React from 'react';
import { Form } from 'antd';
import { NotificationAutoSuggestFields } from '@pushly/models/lib/enums/notification-auto-suggest-fields';
import { getClassNames } from '../../utils';
import { Drawer, Well } from '../index';
import { DEFAULT_DRAWER_FORM_ITEM_LAYOUT } from '../../constants';
import { BetterSelect } from '../better-select/better-select';
import { Domain } from '@pushly/models/lib/structs/domain';
import deepEqual from 'react-fast-compare';

var getChanges = function getChanges(domain, form) {
  var _form$getFieldsValue;

  var validate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var updates = Domain.Builder;
  var values = (_form$getFieldsValue = form === null || form === void 0 ? void 0 : form.getFieldsValue()) !== null && _form$getFieldsValue !== void 0 ? _form$getFieldsValue : {};

  if (domain && form) {
    var _values$notificationA;

    // auto suggest fields
    var valueFields = _toConsumableArray((_values$notificationA = values.notificationAutoSuggestFields) !== null && _values$notificationA !== void 0 ? _values$notificationA : []);

    valueFields.sort();
    var domainFields = !domain.notificationAutoSuggestFields ? null : _toConsumableArray(domain.notificationAutoSuggestFields);
    domainFields === null || domainFields === void 0 ? void 0 : domainFields.sort();

    if (!deepEqual(domainFields, valueFields)) {
      updates.setNotificationAutoSuggestFields(valueFields);
    }
  }

  return updates;
};

export var NotificationAutomationSettingsEditor = function NotificationAutomationSettingsEditor(props) {
  var _domain$notificationA, _domain$notificationA2;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      submitEnabled = _React$useState2[0],
      setSubmitEnabled = _React$useState2[1];

  var visible = props.visible,
      domain = props.domain,
      getAppContainer = props.getAppContainer,
      onEditorSubmit = props.onEditorSubmit,
      onClose = props.onClose;
  var defaultAllowedFields = Object.values(NotificationAutoSuggestFields);

  var handleDrawerClose = function handleDrawerClose() {
    onClose();
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var updates, ok;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return form.validateFields();

            case 2:
              updates = getChanges(domain, form);

              if (updates.isEmpty) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return onEditorSubmit(updates);

            case 6:
              ok = _context.sent;

              if (ok) {
                handleDrawerClose();
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(Drawer, {
    getContainer: getAppContainer,
    className: getClassNames('notif-automation-editor'),
    title: "Update Notification Automation",
    placement: "right",
    closable: true,
    disableSubmit: !submitEnabled,
    onSubmit: handleSubmit,
    onClose: handleDrawerClose,
    visible: visible
  }, /*#__PURE__*/React.createElement(Well, {
    title: "Field Suggestions",
    mode: "ghost",
    hideFooter: true
  }, /*#__PURE__*/React.createElement(Form, _extends({}, DEFAULT_DRAWER_FORM_ITEM_LAYOUT, {
    className: "hide-inline-errors",
    form: form,
    onValuesChange: function onValuesChange() {
      var changes = getChanges(domain, form);
      setSubmitEnabled(Object.keys(changes).length > 0);
    }
  }), /*#__PURE__*/React.createElement(Form.Item, {
    className: getClassNames('ddf-notif-editor-whitelist'),
    name: "notificationAutoSuggestFields",
    label: "Fields",
    initialValue: Array.from((_domain$notificationA = domain.notificationAutoSuggestFields) !== null && _domain$notificationA !== void 0 ? _domain$notificationA : defaultAllowedFields)
  }, /*#__PURE__*/React.createElement(BetterSelect, {
    size: "small",
    mode: "multiple",
    className: "suggested fields",
    placeholder: "No suggested fields",
    disableSearch: true,
    defaultValue: Array.from((_domain$notificationA2 = domain.notificationAutoSuggestFields) !== null && _domain$notificationA2 !== void 0 ? _domain$notificationA2 : defaultAllowedFields),
    options: [{
      value: NotificationAutoSuggestFields.TITLE,
      label: 'Title'
    }, {
      value: NotificationAutoSuggestFields.BODY,
      label: 'Body'
    }, {
      value: NotificationAutoSuggestFields.IMAGE_URL,
      label: 'Image'
    }, {
      value: NotificationAutoSuggestFields.KEYWORDS,
      label: 'Keywords'
    }]
  })))));
};